// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import { assert, CourseType } from '@microsoft/vscodeedu-api';
import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { IntlProps } from './intl-props';

/** Returns display name for a CourseType value. */
export function getCourseTypeText(intl: IntlShape, value: CourseType) {
    switch (value) {
        case 'coding-activity':
            return intl.formatMessage({
                defaultMessage: 'Coding Activity',
                description: 'Course type label.',
            });
        case 'course':
            return intl.formatMessage({
                defaultMessage: 'Course',
                description: 'Course type label.',
            });
        default:
            assert.unreachable(value, 'Unexpected course type value.');
    }
}

/** Course type display text properties. */
export type CourseTypeTextProps = IntlProps<{
    value: CourseType;
}>;

/** Course type display text. */
export const CourseTypeText = injectIntl((props: CourseTypeTextProps) => {
    const { intl, value } = props;
    return <>{getCourseTypeText(intl, value)}</>;
});
